import React from 'react';
import { LuChartColumn, LuGraduationCap, LuNotebookPen } from 'react-icons/lu';
import { useNavigate } from 'react-router-dom';
import useSchoolStore from '../../store/schoolStore';
import PageHeader from '../../components/common/PageHeader';
import MenuButton from '../../components/common/MenuButton';

/**
 * Reports hub: the three kinds of academic report, each with one line on what it shows.
 */
export default function Reports() {
    const { schoolId } = useSchoolStore();
    const navigate = useNavigate();

    const reportModules = [
        {
            id: 'subject-reports',
            title: 'Subject reports',
            description: 'Chapter-wise performance, lesson plan progress and learning outcomes for each subject.',
            icon: <LuNotebookPen />,
            path: `/dash/${schoolId}/reports/lesson-plans`
        },
        {
            id: 'student-reports',
            title: 'Student reports',
            description: 'One student’s performance across subjects, found by admission number.',
            icon: <LuGraduationCap />,
            path: `/dash/${schoolId}/student-report`
        },
        {
            id: 'class-reports',
            title: 'Class reports',
            description: 'Reports made for a whole class or section, with a summary for each student.',
            icon: <LuChartColumn />,
            path: `/dash/${schoolId}/reports/class`
        }
    ];

    return (
        <div className="mx-auto max-w-6xl">
            <PageHeader title="Reports" subtitle="Choose the kind of report you want to see." />
            <div className="grid grid-cols-1 gap-3 md:grid-cols-3">
                {reportModules.map((module) => (
                    <MenuButton
                        key={module.id}
                        title={module.title}
                        subtitle={module.description}
                        icon={module.icon}
                        onClick={() => navigate(module.path)}
                    />
                ))}
            </div>
        </div>
    );
}
